/* Картите с размери поемат ролята на избор.

   Не дублират състояние: при клик натискат истинското радио на темата,
   а подсветката се чете обратно от него. Така, ако размерът се смени
   отвън, картите го отразяват. */
(function () {
  'use strict';

  function realInputs() {
    // радиотата на първата опция (размера), извън нашите карти
    return document.querySelectorAll('.product-form__input--pills input[type="radio"]');
  }

  function sync(cards) {
    var inputs = realInputs();
    var chosen = null;
    Array.prototype.forEach.call(inputs, function (i) { if (i.checked) chosen = i.value; });

    Array.prototype.forEach.call(cards, function (card) {
      var on = card.dataset.lpSize === chosen;
      card.classList.toggle('is-on', on);
      card.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function init() {
    var cards = document.querySelectorAll('[data-lp-size]');
    if (!cards.length) return;

    Array.prototype.forEach.call(cards, function (card) {
      card.setAttribute('role', 'radio');
      card.setAttribute('tabindex', '0');

      function pick() {
        var want = card.dataset.lpSize;
        var inputs = realInputs();
        Array.prototype.forEach.call(inputs, function (i) {
          if (i.value === want && !i.checked) { i.click(); }
        });
        setTimeout(function () { sync(cards); }, 60);
      }

      card.addEventListener('click', pick);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
      });
    });

    // Само един размер в продажба — избира се сам, без човек да прави нищо.
    // Повтаря се при load, защото изборът на темата може да оживее по-късно.
    if (cards.length === 1) {
      var only = function () {
        var want = cards[0].dataset.lpSize;
        Array.prototype.forEach.call(realInputs(), function (i) {
          if (i.value === want && !i.checked) { i.click(); }
        });
      };
      only();
      window.addEventListener('load', only);
    }

    sync(cards);
    document.addEventListener('change', function () { setTimeout(function () { sync(cards); }, 40); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
